// Photo manifest for the fourteen shop-floor photographs shipped in the relaunch kit.
// GENERATED — do not hand-edit anything above the marker at the bottom of this file.
//
// `alt` is copied VERBATIM from _relaunch-kit/manifest.json. It is written for screen
// readers and for image SEO, and it is also written to stay inside the Task 5 pairing
// rule — nothing in it implies the base plate drawing and the welded column bases are
// the same job. Do not paraphrase it.
//
// `widths` and `dims` are read off the actual files, not off the manifest's `widths`
// array: the manifest is stale for base-plate-detail-drawing, which was upscaled 1.5x
// during preparation and ships at 400/800/1200/1600w rather than the 1124w it lists.
// The width in every filename is the TRUE pixel width — nothing else was upscaled, so
// several images top out below 1200w. Do not re-process or re-compress these files;
// they are already sharpened at the limit of what the sources support.

export const PHOTOS = {
  'guardrail-frames-in-production': {
    alt: "Steel guardrail frames stacked in production on an Ontario fabrication shop floor, grinding sparks in the background",
    role: 'hero',
    widths: [400, 800, 1124],
    dims: { 400: [400, 318], 800: [800, 636], 1124: [1124, 893] },
    heroWidths: [800, 1124],
    heroDims: { 800: [800, 450], 1124: [1124, 632] },
  },
  'steel-transport-cages': {
    alt: "Welded steel mesh transport cages finished and staged on a shop loading dock",
    role: 'hero-alt',
    widths: [400, 800, 1200],
    dims: { 400: [400, 277], 800: [800, 553], 1200: [1200, 830] },
    heroWidths: [800, 1200, 1597],
    heroDims: { 800: [800, 450], 1200: [1200, 675], 1597: [1597, 898] },
  },
  'welded-column-base-plates': {
    alt: "Close-up of two welded steel column bases with gusset plates and finished fillet welds",
    role: 'gallery',
    widths: [400, 800, 1124],
    dims: { 400: [400, 347], 800: [800, 695], 1124: [1124, 976] },
  },
  'installed-safety-guardrail': {
    alt: "Finished black-coated steel pipe safety guardrail installed outside a building entrance",
    role: 'gallery',
    widths: [400, 800, 1124],
    dims: { 400: [400, 377], 800: [800, 754], 1124: [1124, 1060] },
  },
  'rebar-cage-flatbed-delivery': {
    alt: "Large welded rebar cage loaded on a flatbed trailer outside a fabrication shop",
    role: 'gallery',
    widths: [400, 800, 1124],
    dims: { 400: [400, 396], 800: [800, 792], 1124: [1124, 1113] },
  },
  'welded-bracket-production-run': {
    alt: "Rows of identical welded steel brackets along structural channel in a production run",
    role: 'gallery',
    widths: [400, 800, 1124],
    dims: { 400: [400, 373], 800: [800, 745], 1124: [1124, 1047] },
  },
  'machined-saddle-mounts-batch': {
    alt: "Pallet of machined and welded steel saddle mounts with drilled bolt holes, batch production",
    role: 'gallery',
    widths: [400, 800, 1200],
    dims: { 400: [400, 533], 800: [800, 1067], 1200: [1200, 1600] },
  },
  'steel-work-platforms-painted': {
    alt: "Two heavy fabricated steel work platforms finished in safety yellow with I-beam legs",
    role: 'gallery',
    widths: [400, 800, 1124],
    dims: { 400: [400, 306], 800: [800, 612], 1124: [1124, 860] },
  },
  'steel-columns-ready-for-delivery': {
    alt: "Large-diameter steel pipe columns strapped to a truck bed ready for delivery",
    role: 'gallery',
    widths: [400, 800, 1124],
    dims: { 400: [400, 380], 800: [800, 760], 1124: [1124, 1068] },
  },
  'welded-tube-handrail-frames': {
    alt: "Welded tube handrail frames with finished tee joints stacked in the shop",
    role: 'gallery',
    widths: [400, 800, 1124],
    dims: { 400: [400, 379], 800: [800, 759], 1124: [1124, 1066] },
  },
  'cnc-machined-component': {
    alt: "Curved steel component clamped in a machine vise on a CNC mill with fresh chips",
    role: 'gallery',
    widths: [400, 739],
    dims: { 400: [400, 866], 739: [739, 1600] },
  },
  'plasma-cut-plate': {
    alt: "Plasma-cut steel plate with a clean circular cutout",
    role: 'gallery',
    widths: [400, 800, 1200],
    dims: { 400: [400, 533], 800: [800, 1067], 1200: [1200, 1600] },
  },
  'welded-bracket-assembly': {
    alt: "Formed and welded steel angle bracket assembly on a welding table",
    role: 'gallery',
    widths: [400, 738],
    dims: { 400: [400, 867], 738: [738, 1600] },
  },
  'base-plate-detail-drawing': {
    alt: "Typical base plate detail drawing: 356x19x356 base plate welded to a W150x22 stub column with 8mm fillet welds",
    role: 'drawing',
    widths: [400, 800, 1200],
    dims: { 400: [400, 262], 800: [800, 525], 1200: [1200, 787] },
  },
};

// ---------------------------------------------------------------------------
// End of generated data. Everything below is hand-maintained.
// ---------------------------------------------------------------------------

// Which of the two hero candidates is live.
//
// Both are supplied as 16:9 hero crops and the brief calls it a real trade-off:
//   'guardrail-frames-in-production' — 1124px max, shop floor mid-production with
//       grinding sparks. More arresting, reads as work happening. Goes soft above
//       ~1100px of viewport width, and its bright sparks sit upper-right.
//   'steel-transport-cages'          — 1597px max, finished cages on the loading
//       dock with a forklift and a worker. Sharper at desktop width and it shows a
//       person, but it is calmer and more static.
//
// Flipping this one value swaps the hero background *and* moves the losing candidate
// into the gallery, so all fourteen photographs stay on the page either way.
export const HERO_SLUG = 'steel-transport-cages';

// The candidate that did not win the hero, rendered as the first gallery tile.
export const HERO_ALT_SLUG =
  HERO_SLUG === 'steel-transport-cages' ? 'guardrail-frames-in-production' : 'steel-transport-cages';

// Reserved for the Task 5 pairing in the Process section, so it is deliberately NOT
// in the gallery — showing it twice on one page weakens it in both places.
export const PAIR_PART_SLUG = 'welded-column-base-plates';
export const PAIR_DRAWING_SLUG = 'base-plate-detail-drawing';

// Gallery order: the losing hero candidate leads, then finished-and-installed work,
// then scale, then repeat runs, then process detail.
export const GALLERY_SLUGS = [
  HERO_ALT_SLUG,
  'installed-safety-guardrail',
  'rebar-cage-flatbed-delivery',
  'welded-bracket-production-run',
  'machined-saddle-mounts-batch',
  'steel-work-platforms-painted',
  'steel-columns-ready-for-delivery',
  'welded-tube-handrail-frames',
  'cnc-machined-component',
  'plasma-cut-plate',
  'welded-bracket-assembly',
];
